export const PromoTypes = {
  SET_PROMO_CODE: "SET_PROMO_CODE"
}